if (!customElements.get('rk-region-explorer')) {
  class RkRegionExplorer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-rk-region-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-rk-region-panel]'));
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick(event) {
      const tab = event.target.closest('[data-rk-region-tab]');
      if (tab && this.contains(tab)) this.selectTab(tab);
    }

    handleKeydown(event) {
      const current = event.target.closest('[data-rk-region-tab]');
      if (!current || !this.contains(current)) return;
      const currentIndex = this.tabs.indexOf(current);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      this.selectTab(this.tabs[nextIndex], true);
    }

    handleBlockSelect(event) {
      const panel = event.target.closest('[data-rk-region-panel]');
      if (!panel || !this.contains(panel)) return;
      const tab = this.querySelector(`#${CSS.escape(panel.getAttribute('aria-labelledby'))}`);
      if (tab) this.selectTab(tab);
    }

    selectTab(tab, focus = false) {
      const panelId = tab.getAttribute('aria-controls');
      this.tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });
      if (focus) tab.focus();
    }
  }

  customElements.define('rk-region-explorer', RkRegionExplorer);
}

if (!customElements.get('rk-collection-tabs')) {
  class RkCollectionTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-rk-cat-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-rk-cat-panel]'));
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick(event) {
      const tab = event.target.closest('[data-rk-cat-tab]');
      if (tab && this.contains(tab)) this.selectTab(tab);
    }

    handleKeydown(event) {
      const current = event.target.closest('[data-rk-cat-tab]');
      if (!current || !this.contains(current)) return;
      const currentIndex = this.tabs.indexOf(current);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      this.selectTab(this.tabs[nextIndex], true);
    }

    handleBlockSelect(event) {
      const panel = event.target.closest('[data-rk-cat-panel]');
      if (!panel || !this.contains(panel)) return;
      const tab = this.querySelector(`#${CSS.escape(panel.getAttribute('aria-labelledby'))}`);
      if (tab) this.selectTab(tab);
    }

    selectTab(tab, focus = false) {
      const panelId = tab.getAttribute('aria-controls');
      this.tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });
      if (focus) tab.focus();
    }
  }

  customElements.define('rk-collection-tabs', RkCollectionTabs);
}
